class Locale {
  id: number;
  cultureName: string;
  displayNameLong: string;
  displayNameShort: string;
  languageRegion: string;

  constructor(
    id: number,
    cultureName: string,
    displayNameLong: string,
    displayNameShort: string,
    languageRegion: string,
  ) {
    this.id = id;
    this.cultureName = cultureName;
    this.displayNameLong = displayNameLong;
    this.displayNameShort = displayNameShort;
    this.languageRegion = languageRegion;
  }
}

export { Locale };
